import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { UserAdminService } from './user-admin.service';
import { UrlShortenerService } from './url-shortener.service';

export const provideDataAccessAuth: () => EnvironmentProviders = () =>
  makeEnvironmentProviders([UserAdminService, UrlShortenerService]);
